<template>
  <!--新建消息-->
    <div class="content AnewMessage">
      <div class="layui-fluid">
        <div class="layui-row">
          <div class="layui-col-md12">
            <!--面包屑-->
            <div class="layui-row">
              <div class="layui-col-md8">
                <span class="layui-breadcrumb" lay-separator=">">
                  <a href="">通知公告</a>
                  <a href="">通知公告列表</a>
                  <a href="">新建消息</a>
                </span>
              </div>
            </div>
            <div class="layui-row" style="margin-top: 20px;">
                <div class="layui-col-md12">
                  <form class="layui-form" action="">
                    <div class="layui-form-item">
                      <label class="layui-form-label" style="width: 110px;">选择分类：</label>
                      <div class="layui-input-block">
                        <select name="interest" lay-filter="aihao">
                          <option value=""></option>
                          <option value="0">写作</option>
                        </select>
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <label class="layui-form-label">标题:</label>
                      <div class="layui-input-block">
                        <input type="text" name="title" lay-verify="title" autocomplete="off" placeholder="请输入标题" class="layui-input">
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <label class="layui-form-label">作者:</label>
                      <div class="layui-input-block">
                        <input type="text" name="title" lay-verify="title" autocomplete="off" placeholder="请输入作者" class="layui-input">
                      </div>
                    </div>
                    <div class="layui-form-item layui-form-text">
                      <div class="layui-input-block">
                        <textarea placeholder="请输入内容" class="layui-textarea"></textarea>
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <label class="layui-form-label">附件:</label>
                      <div class="layui-input-block">
                        <button type="button" class="layui-btn" id="test1">上传图片</button>
                        <p class="layui-elip" style="color: red;font-size: 12px;margin-top: 10px;">最多可上传5个附件，小于20M，仅支持doc、docx、ppt、pptx、txt、pdf类型文件</p>
                        <div class="layui-upload-list">
                          <img class="layui-upload-img" id="demo1">
                          <p id="demoText"></p>
                        </div>
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <div class="layui-input-block">
                        <button type="submit" class="layui-btn" lay-submit="" lay-filter="demo1">保存并发布</button>
                        <button type="reset" class="layui-btn layui-btn-primary">取消</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "AnewMessage",
        data(){
          return {
            msg:''
          }
        },
        methods:{
          // 公共方法
          handlePublics(){
            let _this=this;
            this.$nextTick(()=>{
              layui.use(['jquery','element','table','form'],function () {
                var $ = layui.jquery;
                var element = layui.element;
                var form = layui.form
                var table = layui.table;
                element.render();
                form.render();
                table.render();
              })
            })
          }
        },
        mounted() {
          // 公共方法
          this.handlePublics();
        },
        updated() {
          // 公共方法
          this.handlePublics();
        }
    }
</script>

<style scoped>
  .AnewMessage .layui-form-label{
    width: 100px;
  }
</style>
